var React = require('react');

function Menu (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","d":"M1 6C1 5.44772 1.54721 5 2.22222 5H21.7778C22.4528 5 23 5.44772 23 6C23 6.55228 22.4528 7 21.7778 7H2.22222C1.54721 7 1 6.55228 1 6ZM1 12C1 11.4477 1.54721 11 2.22222 11H21.7778C22.4528 11 23 11.4477 23 12C23 12.5523 22.4528 13 21.7778 13H2.22222C1.54721 13 1 12.5523 1 12ZM1 18C1 17.4477 1.54721 17 2.22222 17H21.7778C22.4528 17 23 17.4477 23 18C23 18.5523 22.4528 19 21.7778 19H2.22222C1.54721 19 1 18.5523 1 18Z"}));
}

Menu.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = Menu;

Menu.default = Menu;
